<script>
import CreationCarteFidForm from "@/containers/compte-client/creation-carte-fid-form";
import { useCreationCarteFidelite } from "./mixin";
import StateOverlay from "@/components/molecules/state-overlay";

export default {
  components: {
    CreationCarteFidForm,
    StateOverlay
  },
  setup() {
    const {
      error,
      state,
      isEligibleDefis,
      isLoading,
      addCarte,
      createCarte,
      isErrorCarteAssociee
    } = useCreationCarteFidelite();

    return {
      error,
      state,
      isEligibleDefis,
      isLoading,
      addCarte,
      createCarte,
      isErrorCarteAssociee
    };
  }
};
</script>

<template>
  <div
    id="content"
    role="main"
  >
    <StateOverlay
      overlay
      :is-loading="isLoading"
    >
      <div class="u-p-none@md u-p-sm">
        <CreationCarteFidForm
          class="u-mt-lg u-mt-none@md u-ml-xlg u-ml-md@lg u-ml-none@md"
          :error="error"
          :state="state"
          :is-eligible-defis="isEligibleDefis"
          :is-error-carte-associee="isErrorCarteAssociee"
          @addCarte="addCarte"
          @createCarte="createCarte"
        />
      </div>
    </StateOverlay>
  </div>
</template>

<style lang="scss" scoped>
</style>
